import PropTypes from 'prop-types'

/**
 * Represents a right level in WEBFLEET that covers one or more individual rights related to a specific entity/topic.
 * WASAPI type.
 *
 * @typedef {Object} RightLevel
 * @property {boolean} [entityAllowed]
 * @property {boolean} [entityGroupAllowed]
 * @property {string} [entityType]
 * @property {string} [group]
 * @property {string} [name]
 * @property {number} [priority]
 * @property {string} [rightLevelId]
 * @property {string} [stringCode]
 */

export const rightLevelPropType = PropTypes.shape({
    entityAllowed: PropTypes.bool,
    entityGroupAllowed: PropTypes.bool,
    entityType: PropTypes.string,
    group: PropTypes.string,
    name: PropTypes.string,
    priority: PropTypes.number,
    rightLevelId: PropTypes.string,
    stringCode: PropTypes.string
})
